const PlayerStatusCode = Object.freeze({
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE"
});
const getStatusInactive = (status) => {
    return status === PlayerStatusCode.INACTIVE;
};

export default { ...PlayerStatusCode, getStatusInactive };
